// removed by extract-text-webpack-plugin
module.exports = {"header":"src-display-platform-Document-InvoiceDetail-header__header--1M0I-","header-left":"src-display-platform-Document-InvoiceDetail-header__header-left--3LJXT","header-right":"src-display-platform-Document-InvoiceDetail-header__header-right--3ncr6"};


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/Document/InvoiceDetail/header.scss
// module id = 6861
// module chunks = 0